import React from 'react';
import PublicHome from '../../components/PublicSite/PublicHome';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';
import loadSiteCopy from '../../components/PublicSite/loadSiteCopy';

// Home lama (stock Wooberly) masih ada di ./Home.js — sengaja tidak dihapus agar
// mudah dibalik: kembalikan Layout + Home di bawah, lalu buang '/' dari
// PUBLIC_ROUTES di server.js.

async function action() {
  await loadSiteCopy();
  return {
    title: 'Bas Recovery — 24/7 Car Recovery & Roadside Assistance in the UAE',
    description: 'Stuck on the road? Bas Recovery sends a verified truck to you in about 25 minutes, anywhere in the UAE. Towing, battery, tyres, fuel and lockouts — 24/7. Call 050 505 2213.',
    component: (
      <HeadLessLayout>
        <PublicHome />
      </HeadLessLayout>
    ),
  };
}

export default action;
